"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoidSelectionOverlay = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const VoidSelectionOverlay = ({ selected }) => {
    if (!selected)
        return null;
    return (React.createElement("div", { contentEditable: false, style: {
            position: 'absolute',
            inset: 0,
            borderRadius: 'inherit',
            background: 'rgba(0, 127, 255, 0.18)',
            pointerEvents: 'none',
        } }));
};
exports.VoidSelectionOverlay = VoidSelectionOverlay;
